import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { removeStorageItem } from '../utils/storage'
import ThemeSelectionWrapper from './ThemeSelectionWrapper'
import { User } from '../types'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user: rawUser, loading: authLoading, isAuthenticated: isAuthFromContext } = useAuth()
  const user = rawUser as User | null

  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!isAuthFromContext) {
    // Clear preferences when session expires
    removeStorageItem('sidebarCollapsed')
    return <Navigate to="/signin" replace />
  }

  // Check if user is on waitlist - redirect to waitlist page
  if (user && user.status === 'waitlist') {
    return <Navigate to="/waitlist" replace />
  }

  return (
    <ThemeSelectionWrapper>
      {children}
    </ThemeSelectionWrapper>
  )
}

export default ProtectedRoute
